import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  margin: 120px 20px 0 20px;
  grid-template-columns: repeat(auto-fill, minmax(min(428px, 100%), 1fr));
  gap: 32px 24px;
`;
